import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LiquidEtherComponent } from '../liquid-ether/liquid-ether.component';
import { Project, ProjectSlug, PublicBlogPost, SitePage } from '../../project-data';

@Component({
  selector: 'app-home-page',
  imports: [LiquidEtherComponent],
  templateUrl: './home-page.component.html',
})
export class HomePageComponent {
  @Input({ required: true }) projects: Project[] = [];
  @Input({ required: true }) propertiesLoading = false;
  @Input({ required: true }) propertiesError = false;
  @Input({ required: true }) blogPosts: PublicBlogPost[] = [];
  @Input({ required: true }) blogLoading = false;
  @Input({ required: true }) blogError = false;
  @Output() readonly homeSectionSelected = new EventEmitter<string>();
  @Output() readonly inquiryRequested = new EventEmitter<void>();
  @Output() readonly blogPostSelected = new EventEmitter<PublicBlogPost>();
  @Output() readonly pageSelected = new EventEmitter<SitePage>();
  @Output() readonly projectSelected = new EventEmitter<ProjectSlug>();

  protected selectProject(event: Event, slug: ProjectSlug): void {
    event.preventDefault();
    this.projectSelected.emit(slug);
  }

  protected useFallbackImage(event: Event, fallbackSrc?: string): void {
    const image = event.target as HTMLImageElement | null;

    if (!image || !fallbackSrc || image.getAttribute('src') === fallbackSrc) {
      return;
    }

    image.src = fallbackSrc;
  }

  protected postMeta(post: PublicBlogPost): string {
    const date = this.postDateLabel(post);
    return post.category ? `${date} / ${post.category}` : date;
  }

  protected postDateLabel(post: PublicBlogPost): string {
    if (!post.published_at) {
      return 'Unscheduled';
    }

    return new Intl.DateTimeFormat('en', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(post.published_at));
  }
}
